export const minimise_alt_reverse = () => (
  <path
    d="M6 11V5a2 2 0 012-2h11a2 2 0 012 2v11a2 2 0 01-2 2h-6m-4 3H3m0 0v-6m0 6l11-11"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
